export const Options = {
    Salutation: [
        { text: "Herr", value: "m" },
        { text: "Frau", value: "w" },
        { text: "Divers", value: "d" },
    ],
    BecomingAwareThroughFormal: [
         { text: "Anzeigen",value:"Anzeigen"},
         { text: "Baustellenwerbung",value:"Baustellenwerbung"},
         { text: "Facebook",value:"Facebook"},
         { text: "Fachmagazine",value:"Fachmagazine"},
         { text: "Fahrzeugwerbung",value:"Fahrzeugwerbung"},
         { text: "Get in Engineering",value:"Get in Engineering"},
         { text: "glassdoor",value:"glassdoor"},
         { text: "Google",value:"Google"},
         { text: "Homepage MBN",value:"Homepage MBN"},
         { text: "Indeed",value:"Indeed"},
         { text: "Instagram",value:"Instagram"},
         { text: "Jobbörsen der Agentur für Arbeit ",value:"Jobbörsen der Agentur für Arbeit "},
         { text: "Jobbörsen der Hochschulen/Universitäten",value:"Jobbörsen der Hochschulen/Universitäten"},
         { text: "kununu",value:"kununu"},
         { text: "LinkedIn",value:"LinkedIn"},
         { text: "Messe",value:"Messe"},
         { text: "Mitarbeiter MBN",value:"Mitarbeiter MBN"},
         { text: "Monster",value:"Monster"},
         { text: "Stepstone",value:"Stepstone"},
         { text: "Xing",value:"Xing"},
         { text: "YouTube",value:"YouTube"},
         { text: "Zeitung",value:"Zeitung"},
         { text: "Sonstiges",value:"Sonstiges"},
    ],
    BecomingAwareThroughInformal: [
        { text:"Anzeigen",value:"Anzeigen"},
        { text:"Azubiyo",value:"Azubiyo"},
        { text:"Baustellenwerbung",value:"Baustellenwerbung"},
        { text:"Facebook",value:"Facebook"},
        { text:"Fachmagazine",value:"Fachmagazine"},
        { text:"Fahrzeugwerbung",value:"Fahrzeugwerbung"},
        { text:"Get in Engineering",value:"Get in Engineering"},
        { text:"glassdoor",value:"glassdoor"},
        { text:"Google",value:"Google"},
        { text:"Homepage MBN",value:"Homepage MBN"},
        { text:"IHK Lehrstellenbörse",value:"IHK Lehrstellenbörse"},
        { text:"Indeed",value:"Indeed"},
        { text:"Instagram",value:"Instagram"},
        { text:"Jobbörsen der Agentur für Arbeit ",value:"Jobbörsen der Agentur für Arbeit "},
        { text:"Jobbörsen der Hochschulen/Universitäten",value:"Jobbörsen der Hochschulen/Universitäten"},
        { text:"kununu",value:"kununu"},
        { text:"LinkedIn",value:"LinkedIn"},
        { text:"Messe",value:"Messe"},
        { text:"Mitarbeiter MBN",value:"Mitarbeiter MBN"},
        { text:"Monster",value:"Monster"},
        { text:"Schule",value:"Schule"},
        { text:"Stepstone",value:"Stepstone"},
        { text:"Xing",value:"Xing"},
        { text:"YouTube",value:"YouTube"},
        { text:"Zeitung",value:"Zeitung"},
        { text:"Sonstiges",value:"Sonstiges"},
    ],
    AdditionalConsent: [
        {text:"Ich willige ein, dass meine Daten für zukünftig zu besetzende Stellen von der MBN-Familie verarbeitet und gespeichert werden dürfen (Bewerberpool). Ein Widerruf ist jederzeit unter der E-Mail Adresse jobs@mbn.de möglich.",value:"Ich willige ein, dass meine Daten für zukünftig zu besetzende Stellen von der MBN-Familie verarbeitet und gespeichert werden dürfen (Bewerberpool). Ein Widerruf ist jederzeit unter der E-Mail Adresse jobs@mbn.de möglich."}
    ]
}
